import { useParams } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import { TaskElementContent } from 'modules/tasks/components/TaskElement/TaskElementContent'
import { useTaskDetails } from 'modules/tasks/components/TaskElement/useTaskDetail'
import { TaskIdentifier } from 'modules/tasks/lib/task'

const TaskDetailPage = () => {
  const { taskId } = useParams()

  const {
    task,
    loading: isLoadingTask,
    canSeePersonalInfo,
    canEditPersonalInfo,
    canEmployeeManageAnyEmployeeFolder,
  } = useTaskDetails({
    ids: [Number(taskId)],
    identifier: TaskIdentifier.Workflow,
  }) // onboarding tasks should always be related to flows

  return (
    <ResponsivePage.Body showHeader={false} loading={isLoadingTask} error={null}>
      <Box flexDirection="column" gap="s16" flexGrow>
        <TaskElementContent
          // eslint-disable-next-line no-type-assertion/no-type-assertion
          task={task!}
          canSeePersonalInfo={canSeePersonalInfo}
          canEditPersonalInfo={canEditPersonalInfo}
          canEmployeeManageAnyEmployeeFolder={canEmployeeManageAnyEmployeeFolder}
          contractVersions={contractVersions}
        />
      </Box>
    </ResponsivePage.Body>
  )
}

export default TaskDetailPage
